import { required } from "@/_helpers/validators";
import { computed, ref } from "vue";
import { useCuiWorkspaceValidation, WorkspaceCreationSteps } from "@coronet/cui";
import { useWorkspaceFormText } from "@/composables/useWorkspaceFormText";

// Re-exported from @coronet/cui so existing `@/composables/useMspWorkspaceModal` imports keep
// working. CreateMspWorkspaceModal builds its own `steps` list, so the enum's member order
// (portal order in cui) does not matter here.
export { WorkspaceCreationSteps };

export function useMspWorkspaceModal() {
  const currentStep = ref(WorkspaceCreationSteps.COMPANY_DETAILS);

  const showPreviousStepBtn = computed(() => {
    return currentStep.value !== WorkspaceCreationSteps.COMPANY_DETAILS;
  });

  const showCompleteBtn = computed(() => {
    return currentStep.value === WorkspaceCreationSteps.REVIEW_SUBSCRIPTION;
  });

  const getCurrentStepNumber = (steps: string[]) => {
    return steps.indexOf(currentStep.value) + 1;
  };

  const getStepsProgress = (steps: string[]) => {
    return (getCurrentStepNumber(steps) * 100) / steps.length;
  };

  const { validationMessages } = useWorkspaceFormText();
  const {
    companyNameRules,
    adminEmailRules,
    supportEmailRules,
    aliasRules,
    brandColorRules,
    displayNameRules,
    domainRules,
  } = useCuiWorkspaceValidation(() => validationMessages.value);

  return {
    required,
    companyNameRules,
    adminEmailRules,
    supportEmailRules,
    aliasRules,
    brandColorRules,
    displayNameRules,
    domainRules,
    currentStep,
    showPreviousStepBtn,
    showCompleteBtn,
    getCurrentStepNumber,
    getStepsProgress,
  };
}
